import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum'

export default {
  Title: 'Στατιστικά',

  Product: {
    Title: 'Στατιστικά Προϊόντων',
    Table: {
      Headers: {
        Id          : '#',
        CategoryName: 'Κατηγορία',
        CatalogName : 'Κατάλογος',
        Name        : 'Προϊόν',
        Quantity    : 'Παραγγελίες',
        UnitQuantity: 'Ποσότητα',
        Sales       : 'Σύνολο Πωλήσεων',
        VatRate     : 'Συντελεστής ΦΠΑ',
        Vat         : 'Σύνολο ΦΠΑ',
        Net         : 'Καθαρό Σύνολο'
      },
      Summary: {
        Title: 'Σύνολα Τρέχουσας Σελίδας'
      },
      Filter: {
        filterCategory: {
          Type       : 'v-select',
          Chips      : true,
          Multiple   : false,
          Label      : 'Κατηγορία Προϊόντων',
          PlaceHolder: 'Όλες οι κατηγορίες προϊόντων',
          ItemText   : 'Name',
          ItemValue  : 'Id',
          ItemDesc   : 'Description',
          Items      : []
        }
      }
    },

    Export: {
      Title         : 'Εξαγωγή',
      Icon          : 'file_download',
      Color         : 'primary',
      SuccessMessage: 'Σύντομα θα λάβετε αρχείο με την εξαγωγή των στατιστικών προϊόντων στα email που επιλέξατε'
    }
  },

  SalesReportOrders: {
    Title: 'Αναφορά Παραγγελιών'
  },

  SalesReportReceiptsZ: {
    Title: 'Αναφορά Παραστατικών (Ζ)',
    Table: {
      Headers: {
        Source     : 'Πηγή',
        Order      : 'Παραγγελία',
        Receipt    : 'Παραστατικό',
        ReceiptType: 'Τύπος Παραστατικού',
        Total      : 'Σύνολο',
        Date       : 'Ημερομηνία'
      }
    },

    Export: {
      Title         : 'Εξαγωγή',
      Icon          : 'file_download',
      Color         : 'primary',
      SuccessMessage: 'Σύντομα θα λάβετε την Αναφορά Πωλήσεων Ζ στο email: {email}'
    },

    Filter: {
      filterOrderType: {
        Type       : 'v-btn-toggle',
        Label      : 'Παραγγελίες',
        PlaceHolder: 'Όλες οι παραγγελίες',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'Όλες'
          },
          {
            Value: 1,
            Name : 'Με Παραστατικό',
            Icon : 'mdi-receipt-text',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Χωρίς Παραστατικό',
            Icon : 'mdi-receipt-text-remove',
            Color: 'orange',
            Class: 'white--text'
          }
        ]
      },

      filterInvoiceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Τύπος Παραστατικού',
        PlaceHolder: 'Όλοι οι τύποι παραστατικού',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : [
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE,
            Name  : 'Τιμολόγιο Πώλησης',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1,
            Name  : 'Πιστωτικό Τιμολόγιο / Συσχετιζόμενο',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2,
            Name  : 'Πιστωτικό Τιμολόγιο / Μη Συσχετιζόμενο',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT,
            Name  : 'Απόδειξη Λιανικής Πώλησης',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT,
            Name  : 'Απόδειξη Παροχής Υπηρεσιών',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT,
            Name  : 'Πιστωτικό Στοιχ. Λιανικής',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER,
            Name  : 'Δελτίο Παραγγελίας Εστίασης',
            Avatar: {
              Color: 'blue-grey',
              Icon : 'mdi-receipt-text'
            }
          }
        ]
      },

      filterSourceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Πηγή Παραγγελίας',
        PlaceHolder: 'Όλες οι πηγές παραγγελίας',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : []
      }
    }
  },

  OrdersHeatmap: {
    Title : 'Heatmap Παραγγελιών',
    Orders: 'Δεδομένα από {orders} παραγγελίες'
  }
}
